<script lang="ts">
	import RoundClose from 'virtual:icons/ic/round-close';
	import Container from '../Container.svelte';
	import { fade, fly } from 'svelte/transition';
	import { createEventDispatcher } from 'svelte';
	import { clickoutside } from '@svelte-put/clickoutside';
	import { twMerge } from 'tailwind-merge';

	const dispatch = createEventDispatcher();

	let className = '',
		style = '',
		title = '',
		dialogElement: HTMLDialogElement | null = null;

	export { title, className as class, style };

	// Focus on the dialog when it's opened
	$: if (dialogElement) dialogElement.focus();
</script>

<dialog
	on:close={() => dispatch('close')}
	bind:this={dialogElement}
	aria-labelledby="dialog-title"
	aria-modal="true"
	in:fade={{ duration: 350 }}
	out:fade={{ duration: 350, delay: 350 }}
	class="drawer fixed inset-0 z-[100] grid size-full place-items-end bg-base-100 bg-black/30"
>
	<div
		use:clickoutside
		on:clickoutside
		in:fly={{ duration: 350, delay: 350, y: 200 }}
		out:fly={{ duration: 350, y: 200 }}
		class="drawer-content w-full {twMerge('min-h-24 rounded-t-2xl bg-base-100 pb-5', className)}"
		{style}
	>
		<Container>
			<div class="sticky top-0 flex items-center gap-3 bg-base-100 py-5">
				<button
					on:click={() => dispatch('close')}
					type="button"
					aria-label="Close dialog"
					class="btn btn-circle"
				>
					<RoundClose class="text-2xl" />
				</button>
				<p id="dialog-title" class="text-lg font-semibold">{title}</p>
			</div>
			<slot />
		</Container>
	</div>
</dialog>
